module.exports = __webpack_public_path__ + "img/logo.f3c0025d.svg";